import { Injectable } from '@angular/core';
import { ConsoleService } from '../console/console.service';

@Injectable({
  providedIn: 'root'
})
export class ElementService {

  constructor(
    public srvConsole: ConsoleService,
  ) { }

  // Obtiene el elemento si el ID es válido
  data(value: any): HTMLElement | null {
    // Retornar resultado verificado
    return this.check(value);
  }

  // Valida si el elemento con el ID proporcionado existe
  check(value: any): HTMLElement | null {
    if (typeof value !== 'string' || value.trim() === '') {
      let mssg = `id inválido ${value}`;
      this.srvConsole.error(false, mssg);
      return null;
    }

    const element = document.getElementById(value);
    if (!element) {
      let mssg = `element not found ${value}`;
      this.srvConsole.error(false, mssg);
      return null;
    }

    return element;
  }

  // Método para clases de un elemento
  list(
    action: 'add' | 'rmv',
    value: string,
    apply: string
  ): void {
    let mssg = `action not found ${action}`;
    const element = this.check(value);
    if (element) {
      switch (action) {
        case 'add':
          element.classList.add(apply);
          break;
        case 'rmv':
          element.classList.remove(apply);
          break
        default:
          this.srvConsole.error(
            false,
            mssg
          );
          break;
      }
    }
  }
}
